import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { Backdrop, CircularProgress, TextField } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import Autocomplete from '@material-ui/lab/Autocomplete'
import Divider from '@material-ui/core/Divider'
//*antd
import Modal from 'antd/es/modal';
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'

const TelematicsAsignTechnician = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const history = useHistory()

    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [installerId, setInstallerId] = useState(0)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/AsignTechnician/',
            linkLegend: t('telematicsDetail.asignTechnician'),
            urlParams: [{ key: 'branchOfficeId', value: props.match.params.branchOfficeId }, { key: 'instalationId', value: props.match.params.instalationId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Technicians(props.userLanguage, props.userToken, props.match.params.branchOfficeId, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    //*First Render Functions
    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSaveTechnician = (response) => {
        handleCloseBackdrop()
        history.push(`/telematics/listByStatus/EnProceso&${props.match.params.branchOfficeId}`)
    }

    const saveTechnician = () => {
        if (installerId !== 0) {
            props.actions.assing_Technician(props.userLanguage, props.userToken, props.match.params.instalationId, installerId, onError, onSuccessSaveTechnician)
        }else{
            console.log("error")
        }
    }


    //*Funtions Error & Navigation
    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: <Typography variant="body1" style={{ fontWeight: 600 }}>{t('commonMessages.alert500')}</Typography>
                    })
                    break
                default:
                    break
            }
        }
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid item xs={12}><br /></Grid>
                <Container className={classes.generalBorder}>
                    <Grid container item xs={12} spacing={3} >
                        <Grid item xs={12} >
                            <p className={classes.titles}>{t(`telematicsDetail.asignTechnician`)}</p>
                        </Grid>
                    </Grid>
                    <Divider />
                    <Grid container spacing={1}>
                        <Grid item xs={12} >
                            <Grid item xs={12}><br /></Grid>
                            <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                <Grid item xs={5}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.numberOrderInstalation')}</Typography>
                                    <TextField variant="outlined" value={props.match.params.instalationId} size="small" fullWidth disabled={true} />
                                </Grid>
                                <Grid item xs={1}><br /></Grid>
                                <Grid item xs={5}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsInstallers.technicianName')}</Typography>
                                    <Autocomplete
                                        disableClearable={true}
                                        onChange={(event, newValue) => {
                                            setEmail(newValue.email)
                                            setPhone(newValue.phone)
                                            setInstallerId(newValue.id)
                                        }}
                                        fullWidth={true}
                                        size="small"
                                        options={props.technicianList}
                                        getOptionLabel={(option) => option.name}
                                        getOptionSelected={(option, value) => option.name === value.name}
                                        renderInput={(params) => <TextField {...params} fullWidth label={''} variant="outlined" />}
                                    />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}><br /></Grid>
                            <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                <Grid item xs={5}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.email')}</Typography>
                                    <TextField value={email} disabled={true} variant="outlined" size="small" fullWidth />
                                </Grid>
                                <Grid item xs={1}><br /></Grid>
                                <Grid item xs={5}>
                                    <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.telephoneNumber')}</Typography>
                                    <TextField
                                        type="number"
                                        min="0"
                                        value={phone}
                                        error={phone < 0}
                                        disabled={true}
                                        helperText={phone < 0 ? t('commonMessages.noLess') : ''}
                                        inputProps={{
                                            pattern: "[0-9]"
                                        }}
                                        variant="outlined" size="small" fullWidth />
                                </Grid>
                            </Grid>
                            <Grid item xs={12}><br /></Grid>
                            <Grid item xs={12} className={classes.buttonAlign}>
                                <Button variant="outlined" onClick={saveTechnician} className={classes.generalBorder}>{t('common.save')}</Button>
                            </Grid>
                            <Grid item xs={12}><br /></Grid>
                        </Grid>
                    </Grid>
                </Container>
                <Grid item xs={12}><br /></Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    technicianList: state.TelematicsReducer.technicianList,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsAsignTechnician))